class NotificationBar extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    const closeButton = document.querySelector('[data-notification-bar-close-button]');
    const notificationBar = document.querySelector('[data-notification-bar]').closest('.notification-bar');

    closeButton.addEventListener('click', () => {
      notificationBar.style.maxHeight = '0';
    });
  }
}

window.NotificationBar = NotificationBar;
customElements.define('notification-bar', NotificationBar);
